import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { isLoggedIn } from "./../../util";
import {
  UploadUserCsv,
  dismissLogs,
  initiateUpload,
  UploadDealerCsv,
} from "../../actions/control_panel_action";
import { Grid, Dimmer, Loader, Button, Modal } from "semantic-ui-react";
import CommonForAllPannels from "./CommonForAllPannels.jsx";

class DamagesControlPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      damagesuserCsvFile: null,
      damagesdealersCsvFile: null,
    };
  }

  componentWillMount() {
    if (!isLoggedIn(this.props.auth)) {
      this.props.history.push(`/login`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isLoggedIn(nextProps.auth)) {
      this.props.history.push(`/login`);
      return false;
    }
    return true;
  }

  damageshandleUserFileUpload = (files) => {
    const file = files.target.files[0];
    this.setState({ damagesuserCsvFile: file });
    files.target.files = null;
  };

  damageshandleDealerFileUpload = (files) => {
    const file = files.target.files[0];
    this.setState({ damagesdealersCsvFile: file });
    files.target.files = null;
  };

  damagesuploadUserData = () => {
    let damagesUserUrl = "/admin/v1/damages/addUsers";
    this.props.initiateUpload(true);
    this.props.uploadUserCsv(damagesUserUrl, this.state.damagesuserCsvFile);
  };

  damagesuploadDealerData = () => {
    let damagesDealerUrl = "/admin/v1/damages/addMaster";
    this.props.initiateUpload(true);
    this.props.uploadDealerCsv(
      damagesDealerUrl,
      this.state.damagesdealersCsvFile
    );
  };

  damagescloseLog = () => {
    this.props.dismissLogs(false);
  };

  render() {
    let damagesPannel = [
      {
        itemForSpan: "Upload User CSV to add Users",
        itemInputChange: this.damageshandleUserFileUpload,
        itemClickButton: this.damagesuploadUserData,
        itemContentForButton: "Upload User CSV",
      },
      {
        itemForSpan: "Upload Damages Master CSV to add Master",
        itemInputChange: this.damageshandleDealerFileUpload,
        itemClickButton: this.damagesuploadDealerData,
        itemContentForButton: " Upload Damages Master",
      },
    ];
    return (
      <div
        style={{
          marginLeft: "2vw",
          marginTop: "7vh",
          fontWeight: "bold",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <Dimmer active={this.props.controlPanel.uploadIncomplete}>
          <Loader size="massive">Uploading</Loader>
        </Dimmer>
        <Grid columns={2}>
          <Grid.Row>
            <CommonForAllPannels
              child={damagesPannel}
              color={this.props.color}
            />
          </Grid.Row>
        </Grid>
        {this.props.controlPanel.showLog && (
          <Modal
            close={this.damagescloseLog}
            open={this.props.controlPanel.showLog}
          >
            <Modal.Header>Upload Report</Modal.Header>
            <Modal.Content>
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.controlPanel.log,
                }}
              />
            </Modal.Content>
            <Modal.Actions>
              <Button color="black" onClick={this.damagescloseLog}>
                Dismiss
              </Button>
            </Modal.Actions>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    home: state.home,
    controlPanel: state.controlPanel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      uploadUserCsv: UploadUserCsv,
      uploadDealerCsv: UploadDealerCsv,
      initiateUpload: initiateUpload,
      dismissLogs: dismissLogs,
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DamagesControlPanel)
);
